import React from "react";

const SECTIONS = [
  {
    title: "1. Responsable du traitement",
    content:
      "Le responsable du traitement des données personnelles collectées sur PixyQuiz est l'éditeur de la plateforme. Pour toute question relative à vos données, vous pouvez nous contacter via la page « Contactez-nous ».",
  },
  {
    title: "2. Données collectées",
    content:
      "Nous collectons les données suivantes lors de votre inscription et de l'utilisation du service : pseudo, adresse e-mail, âge, ville ou région (optionnel), avatar, historique de jeu et scores. Ces données sont nécessaires au fonctionnement du service.",
  },
  {
    title: "3. Finalités du traitement",
    content:
      "Vos données sont utilisées pour : gérer votre compte et votre connexion, afficher votre profil et vos statistiques, calculer les classements, personnaliser votre expérience de jeu, envoyer des notifications liées au service.",
  },
  {
    title: "4. Base légale",
    content:
      "Le traitement de vos données est fondé sur l'exécution du contrat (CGU) que vous avez accepté lors de votre inscription, ainsi que sur notre intérêt légitime à assurer le bon fonctionnement et la sécurité de la plateforme.",
  },
  {
    title: "5. Durée de conservation",
    content:
      "Vos données sont conservées pendant toute la durée d'activité de votre compte. En cas de suppression de votre compte, vos données personnelles sont effacées dans un délai raisonnable, à l'exception des données que nous sommes légalement tenus de conserver.",
  },
  {
    title: "6. Partage des données",
    content:
      "Nous ne vendons ni ne louons vos données personnelles à des tiers. Certaines données peuvent être partagées avec des prestataires techniques nécessaires au fonctionnement du service (hébergement, e-mails transactionnels), dans le strict respect du RGPD.",
  },
  {
    title: "7. Vos droits (RGPD)",
    content:
      "Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants : accès, rectification, effacement, limitation, portabilité et opposition au traitement de vos données. Pour exercer ces droits, contactez-nous via la page « Contactez-nous ».",
  },
  {
    title: "8. Cookies",
    content:
      "La plateforme utilise des cookies techniques nécessaires à son fonctionnement. Pour plus d'informations, consultez notre Politique de cookies.",
  },
];

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen bg-slate-50">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-sky-600">
            LÉGAL
          </p>
          <h1 className="mt-3 text-4xl font-black text-slate-950">
            Politique de confidentialité
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="space-y-6">
          {SECTIONS.map((section) => (
            <div
              key={section.title}
              className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"
            >
              <h2 className="text-lg font-black text-slate-950">
                {section.title}
              </h2>
              <p className="mt-3 text-sm leading-7 text-slate-600">
                {section.content}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
